import { jsx as o } from "react/jsx-runtime";
import * as a from "react";
import { forwardRef as c } from "react";
import { c as n } from "./index.js-Cr0Rsuyz.mjs";
import { c as i } from "./tw-cn-mXgPecoF.mjs";
import { c as m } from "./index-BpNK5r1N.mjs";
function s(t, r) {
  return /* @__PURE__ */ a.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "164",
    height: "60",
    fill: "none",
    viewBox: "0 0 164 60",
    ref: r
  }, t), /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M88.405 0c-16.542 0-30 13.458-30 30s13.458 30 30 30 30-13.458 30-30-13.455-30-30-30m0 47.246c-9.508 0-17.246-7.735-17.246-17.246 0-9.512 7.734-17.246 17.246-17.246S105.651 20.488 105.651 30s-7.735 17.246-17.246 17.246M40.98 32.428 29.46 10.031c-3.17-5.906-9.673-8.78-16.18-7.15C6.767 4.514 2.394 10.115 2.394 16.814v39.18c0 .493.4.894.893.894H14.15c.493 0 .894-.4.894-.893V16.972c0-.334 0-1.512 1.316-1.843 1.314-.33 1.92.77 2.078 1.065l21.418 39.757c.311.579.913.94 1.572.94h11.241c.493 0 .894-.401.894-.894V4.013c0-.493-.4-.893-.894-.893H41.877c-.493 0-.894.4-.894.893v28.415zM142.787 44.05a6.71 6.71 0 0 1-6.709-6.709V4.006c0-.493-.4-.893-.893-.893h-11.09c-.493 0-.893.4-.893.893V38.05c0 10.405 8.433 18.838 18.838 18.838h18.672c.493 0 .893-.4.893-.893V44.94c0-.492-.4-.893-.893-.893h-17.928z"
  }));
}
var l = n(/* @__PURE__ */ c(s));
const d = m("w-fit", {
  variants: {
    theme: {
      brand: "text-brand-main",
      gray_medium: "text-fill-neutral-medium",
      gray_weak3: "text-fill-neutral-weak3",
      white: "text-static-white"
    }
  },
  defaultVariants: {
    theme: "brand"
  }
}), f = ({ theme: t = "brand", className: r }) => {
  const e = d({ theme: t });
  return /* @__PURE__ */ o(l, { className: i(e, r) });
};
f.displayName = "NDS.BrandLogo";
export {
  f as B
};
